import { render, staticRenderFns } from "./MixedChart.vue?vue&type=template&id=bf8d0f38"
import script from "./MixedChart.vue?vue&type=script&lang=ts"
export * from "./MixedChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports